// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".circle-image[data-v-5f4015c4]{width:50%}.circle-image[data-v-5f4015c4]:first-child{margin-right:10px}img[data-v-5f4015c4]{transition:all .5s}img[data-was-processed=true][data-v-5f4015c4]{opacity:1}img[data-was-processed=false][data-v-5f4015c4]{opacity:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
